import Component from './component'
import NavigationItem from './navigation'
import Theme from './theme'
import { types as t } from '@invisr/mobx-state-tree'
import Auditable from './auditable'
import crudActions from './crud-actions'
import ref from './reference'
import type { Instance } from '@invisr/mobx-state-tree'

export const Assignment = t
  .model({
    id: t.identifier,
    name: t.maybeNull(t.string),
    description: t.maybeNull(t.string),
    group: t.maybeNull(t.string),
    device: 'desktop',
    layout: ref(Component, 'layouts'),
    theme: ref(Theme, 'themes'),
    navigation: ref(t.late(() => NavigationItem), 'navigation')
  })
  .actions(crudActions)

export default t.compose(
  'Assignment',
  Assignment,
  Auditable
)
export type IAssignment = Instance<typeof Assignment>
